import { render, staticRenderFns } from "./view04.vue?vue&type=template&id=7378c240&scoped=true"
import script from "./view04.vue?vue&type=script&lang=js"
export * from "./view04.vue?vue&type=script&lang=js"
import style0 from "./view04.vue?vue&type=style&index=0&id=7378c240&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7378c240",
  null
  
)

export default component.exports